import React, { useEffect } from 'react';
import clsx from 'clsx';
import withStyles from 'react-jss';
import { webConfig } from '../../configs/system.configs';
import { loadNewBody, revertBody } from '../../utils/Utils';
import styles from './styles';

const bodyClass = ['1-colum', 'bg-full-screen-image', 'blank-page'];
const baseUrl = webConfig.webUrl;

const Error404 = ({ classes }) => {
  const { pathname } = window.location;

  useEffect(() => {
    loadNewBody(bodyClass);
    return () => {
      revertBody(bodyClass);
    };
  }, []);

  // Nếu muốn ẩn khi unauthorized (giữ logic cũ nhưng comment lại)
  // if (pathname.includes('unauthorized')) return null;

  return (
    <div className="row">
      <div className="col s12 center-align white">
        <img
          src={`${baseUrl}/assets/images/gallery/error-2.png`}
          className={clsx('bg-image-404', classes.root)}
          alt="404-page-img"
        />
        <h1 className="error-code m-0">404</h1>
        <h6 className="mb-2">Not found here</h6>
      </div>
    </div>
  );
};

export default withStyles(styles)(Error404);
